<script>
import BountyIconSymbol from '@/components/viewer/bounty/BountyIconSymbol'

// These elements are referenced by svg <use>
// and just need to be anywhere on the page.
export default {
    functional: true,
    render () {
        return (
            <div id="global-svg-symbols">
                <BountyIconSymbol/>
            </div>
        )
    }
}
</script>

<style lang="scss" scoped>
#global-svg-symbols {
    position: fixed;
    left: -9999px;
}
</style>
